import styled from 'styled-components';

export const Container = styled.div`
  position: fixed;
  z-index: 1001;
  pointer-events: none;
  width: 100vw !important;
  left: 0 !important;
  overflow: hidden;

  > * {
    transform: translateY(-${(props) => props.style.top}px);
  }
`;

const Selection = styled.div`
  position: absolute;
  box-sizing: border-box;

  > * {
    pointer-events: auto;
  }
`;

export const NameEditorContainer = styled(Selection)``;

export const MarkupMenuContainer = styled(Selection)`
  z-index: 1;
`;
